module.exports = __webpack_public_path__ + "img/122.87914f30.jpg";